import { Checkbox } from "@mui/material";
import type { ChangeEvent } from "react";

import InfoTooltip from "../InfoTooltip";
import styles from "./style.module.scss";

interface CheckboxQuestion {
    checked: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    text: string;
    textStyle?: React.CSSProperties;
    infoTooltip?: { text: string; link?: string; type: "info" | "question" };
}

/**
 * Used mainly in forms to trigger an action --> [] Do you use this ?
 * and when checked something happens (like displaying a field or sth)
 */
const CheckboxQuestion = ({ checked, onChange, text, textStyle, infoTooltip }: CheckboxQuestion) => {
    return (
        <div className={styles["checkbox-question"]}>
            <Checkbox checked={checked} onChange={onChange} className={styles["checkbox"]} id="checkbox" />
            <label style={textStyle} htmlFor="checkbox">
                {text}
            </label>
            {infoTooltip && <InfoTooltip text={infoTooltip.text} iconType={infoTooltip.type} link={infoTooltip.link} />}
        </div>
    );
};
export default CheckboxQuestion;
